var React = require("react");
var { fetchAccessTokenFromCode, storeAccessToken, formLoginPreferencesLink } = require('../../LPAuthUtils/AuthUtil');
var OAuthClientConfig = require('../../LPAuthUtils/OAuthClientConfig');

class LoginPreferencesHandleAuth extends React.Component {
    constructor(props) {
        super(props);
        this._handleAuth = this.handleAuth.bind(this);
    }
    componentDidMount() {
        console.log("window.location : ", window.location)
        this._handleAuth();
    }

    handleAuth() {
        const isInIFrame = (window.location != window.parent.location);
        var windowLocation = window.location;
        var authCodeRespParams = {};
        windowLocation.hash.replace('#', '').split('&').forEach(item => {
            authCodeRespParams[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
        });

        const loginpreferencesLink = formLoginPreferencesLink(OAuthClientConfig, windowLocation.href);

        if (authCodeRespParams.code !== undefined) {
            localStorage.setItem('session_state_lp2', authCodeRespParams.session_state);

            fetchAccessTokenFromCode(OAuthClientConfig, authCodeRespParams.code, windowLocation.href).then((accessTokenResp) => {
                if (accessTokenResp.error !== undefined) {
                    if (isInIFrame) {
                        //Trigger event onSilentAuthError
                        var evt = new CustomEvent('onSilentAuthError', {
                            detail: {
                                errorDetails: error
                            }
                        });

                        window.parent.dispatchEvent(evt);
                    }
                    else
                        window.location.href = loginpreferencesLink;

                } else if (accessTokenResp.access_token !== undefined) {
                    storeAccessToken(accessTokenResp.access_token, accessTokenResp.id_token);
                    if (isInIFrame) {
                        //Trigger event onSilentAuthSuccess
                        var evt = new CustomEvent('onSilentAuthSuccess');
                        window.parent.dispatchEvent(evt);
                    }
                    else
                        window.location.href = loginpreferencesLink;

                }
            });
        }
        else {
            //No code found in response from authorize request in redirect_uri
            console.log("No code in auth response");
            window.location.href = loginpreferencesLink;
        }
    }


    render() {
        return (
            <div></div>
        )
    }
}



module.exports = LoginPreferencesHandleAuth;